import inSection from "./in-section.util";

export const SALES_COACH_DESTINATIONS = inSection("/sales-coach", [
  { to: "opportunities", label: "Opportunities" },
  { to: "training", label: "Training" },
  { to: "playbook", label: "Playbook" }
]);
